export default __webpack_public_path__ + "white_h_logo.png";